import React from "react";

export const Logo = ({ size = "default", animated = true }) => {
    const sizes = {
        small: { bar: "w-[3px]", gap: "gap-[3px]", text: "text-xl", h: "h-7" },
        default: {
            bar: "w-[4px]",
            gap: "gap-[4px]",
            text: "text-2xl",
            h: "h-8",
        },
        large: { bar: "w-[6px]", gap: "gap-[6px]", text: "text-4xl", h: "h-12" },
    };
    const s = sizes[size] || sizes.default;
    const heights = ["h-3", "h-6", "h-4", "h-7", "h-5"];

    return (
        <div className="flex items-center gap-3" data-testid="maajja-logo">
            <div className={`flex items-end ${s.h} ${s.gap}`}>
                {heights.map((h, i) => (
                    <span
                        key={i}
                        className={`${s.bar} ${h} bg-[#791EE2] rounded-sm ${
                            animated ? "eq-bar" : ""
                        }`}
                        style={{ animationDelay: `${i * 0.15}s` }}
                    />
                ))}
            </div>
            <span
                className={`font-logo font-extrabold lowercase text-white ${s.text}`}
            >
                maajja
            </span>
        </div>
    );
};
